// Port of api/fuel/app/classes/filter/search/games/filters/query/game/published.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	name: 'game.published',
	priority: 20,
	require: function(config, filter) {
		return filter.year.from !== 1970 || filter.year.to !== 2030
	},
	run: function(config, filter, data, query) {
		if (config.ownerType === F.OWNER_USER && config.resultType === F.RESULT_COLLECTION) {
			// Collection context: v is JOINed, OR group works correctly
			query.whereGroup('OR', [
				['AND', [
					['g.game_published', '>=', filter.year.from],
					['g.game_published', '<=', filter.year.to]
				]],
				['AND', [
					['v.game_version_year', '>=', filter.year.from],
					['v.game_version_year', '<=', filter.year.to]
				]]
			])
		} else if (config.ownerType === F.OWNER_USER) {
			// Non-collection: use game_published only. PHP's OR group with version year
			// gets split by the query builder and behaves differently depending on
			// boosting. The offline engine replaces boosting, so just use game_published.
			query.where('g.game_published', '>=', filter.year.from)
			query.where('g.game_published', '<=', filter.year.to)
		} else {
			query.where('g.game_published', '>=', filter.year.from)
			query.where('g.game_published', '<=', filter.year.to)
		}
	}
}
